import { LOG_TYPE } from '../const';
import { logger } from '../logger/logger.class';
/**
 * Injects `<script defer src="https://remote-source-of-js-file.js"></script>` tag with lazy loaded scripts
 * @param url string remote source for JS script
 * @param html script body
 * @returns `PromiseLike<void> | unknown`
 */
export function injectScript(url, body) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        if (url && body) {
            logger.message('Provive either URL of the remote script OR script\'s innerHTML content', LOG_TYPE.warning);
            return;
        }
        script.src = url;
        script.innerHTML = body;
        script.type = 'text/javascript';
        script.async = true;
        script.addEventListener('load', resolve);
        script.addEventListener('error', reject);
        document.head.appendChild(script);
    });
}
